import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router';

import {ErrorAlert} from '../common/ErrorAlert';
import {ErrorResponse, InventoryStock} from '../api/dtos/dtos';
import furoApi from '../api/FuroApi';
import * as paths from '../paths';
import locales from '../locales';
import {
  ApplicationContextConsumer,
  bindLoadingHandler,
  LoadingOverlayHandler,
  withLoadingOverlay
} from '../app/ApplicationContext';
import {setAppHeaderSubtitle} from '../app/AppHeader';
import SectionHeaderFormItem from "../common/form-items/SectionHeaderFormItem";
import InventoryStockItemsEditor from "./InventoryStockItemsEditor";
import InventoryStockDetailsAlert from './InventoryStockDetailsAlert';

interface State {
  stock?: InventoryStock;
  error?: ErrorResponse;
}

class InventoryStockDetailsPage extends React.Component<RouteComponentProps<paths.IdPageUrlParams>, State> {

  public readonly loadingHandler?: LoadingOverlayHandler;

  public state: State = {};

  public componentDidMount() {
    this.reload();
  }

  public render() {
    const {stock, error} = this.state;

    return (
      <>
        <ApplicationContextConsumer>
          {({loadingHandler}) => bindLoadingHandler(loadingHandler, this)}
        </ApplicationContextConsumer>

        {stock &&
            <>
                <InventoryStockDetailsAlert stock={stock}/>
                <SectionHeaderFormItem title={locales.inventory_stock_items} style={{marginTop: 0}}/>
                <InventoryStockItemsEditor inventoryStock={stock} infiniteStock={stock.infiniteStock}/>
            </>
        }
        <ErrorAlert style={{marginTop: '16px'}} error={error}/>
      </>
    );
  }

  private getIdParam = (): number => {
    return Number(this.props.match.params.id);
  };

  private reload = () => {
    const promise = furoApi.inventoryStocks.get(this.getIdParam())
      .then(this.onLoadSuccess)
      .catch(this.onApiError);
    withLoadingOverlay(promise, this.loadingHandler);
  };

  private onLoadSuccess = (response: InventoryStock) => {
    this.setState({
      stock: response,
      error: undefined,
    });
    setAppHeaderSubtitle(this.props, response.name);
  };

  private onApiError = (error: ErrorResponse) => {
    this.setState({error});
  };
}

export default withRouter(InventoryStockDetailsPage);



// WEBPACK FOOTER //
// ./src/inventory-stock-details/InventoryStockDetailsPage.tsx